(function (SiteNav, $) {
  'use strict';

  var $wrapper;
  var $item;

  var cacheDom = function () {
    $wrapper = $('.js-nav-inner-wrapper');
    $item = $wrapper.find('.js-nav-hover-item');
  };

  var bindUIActions = function () {
    $item.on('mouseenter', function () {
      var $this = $(this);
      var text = $this.attr('data-text');
      var image = $this.attr('data-image');
      var href = $this.attr('data-href');
      var $parent = $this.parents('.js-nav-inner-wrapper');

      $parent.find('.js-nav-text').text(text);
      $parent.find('.js-nav-image').attr('src', image);
      $parent.find('.js-nav-link').attr('href', href);
    });
  };

  var init = function () {
    cacheDom();
    bindUIActions();
  };

  SiteNav.init = init;
})(window.SiteNav = window.SiteNav || {}, jQuery);
